import { motion } from "framer-motion";
import "./PrivateCoaching.css";
import heroImg from "../assets/hero-private.jpg";
import coachImg from "../assets/coach-photo.webp";
import trophyImg from "../assets/trophy.jpg";
import { Link } from "react-router-dom";

export default function PrivateCoaching() {
  return (
    <motion.section
      className="private-page"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* === Hero Banner === */}
      <div
        className="hero-banner"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay">
          <h1>Private Badminton Coaching – Melbourne</h1>
          <p>Focused. Personalised. Goal-Driven Training at SmashKaro.</p>
          {/* 🔸 Redirect to Availability Form */}
          <Link to="/availability" className="hero-btn">Enroll Now</Link>
        </div>
      </div>

      {/* === Overview Section === */}
      <div className="overview">
        <h2>Customised To Your Game, Goals & Growth</h2>
        <p>
          Our private coaching sessions are designed for players who want
          focused, professional guidance to accelerate their badminton development.
        </p>
        <p>
          At <strong>SmashKaro</strong>, private lessons follow structured
          training blocks that deliver clear progress, targeted feedback, and
          long-term improvement.
        </p>
      </div>

      {/* === Pricing Section === */}
      <div className="pricing-section">
        <h2>1-on-1 Coaching Options</h2>
        <table className="pricing-table">
          <thead>
            <tr>
              <th>Session Type</th>
              <th>Players</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Private Coaching</td>
              <td>1 Player</td>
              <td>$40 / hour</td>
            </tr>
            <tr>
              <td>Private Coaching</td>
              <td>2 Players</td>
              <td>$40 / hour (per player)</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* === Location Section === */}
      <div id="book" className="location-section">
        <h2>Where We Train</h2>
        <p>
          <strong>ABC – Abbotsford Badminton Club</strong><br />
          18 Flockhart St, Abbotsford VIC 3067
        </p>
        <div className="map-container">
          <iframe
            title="ABC Abbotsford Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.678364942166!2d144.99557547572717!3d-37.80618993351409!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642cf0db2a4b9%3A0x4b19575c5c3514b9!2sAbbotsford%20Badminton%20Club!5e0!3m2!1sen!2sau!4v1695053707123!5m2!1sen!2sau"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* === Meet the Coach === */}
      <div className="coach-section">
        <img src={coachImg} alt="Coach" className="coach-photo" />
        <div className="coach-info">
          <h2>Meet Your Coach</h2>
          <p>
            With over 10 years of experience coaching juniors and adults across
            Melbourne, our head coach helps players reach their best level.
          </p>
        </div>
      </div>

      {/* === Book Now Footer === */}
      <div className="book-section" style={{ backgroundImage: `url(${trophyImg})` }}>
        <div className="book-overlay">
          <h2>Ready to Train Smarter?</h2>
          {/* 🔸 Redirect to Availability Form */}
          <Link to="/availability" className="hero-btn">Book Now</Link>
        </div>
      </div>
    </motion.section>
  );
}
